<template>
  <oie-info-wrapper>
    <oie-info-wrapper-item>
      <p>{{ tStatic('machineCustomerNo') }}</p>
      <p>{{ machineOwner.endCustomerNumber ? machineOwner.endCustomerNumber : tStatic('machineCustomerNoNotSpecified') }}</p>
    </oie-info-wrapper-item>
    <oie-info-wrapper-item>
      <p>{{ tStatic('otherInfo') }}</p>
      <p>{{ machineOwner.info }}</p>
    </oie-info-wrapper-item>
  </oie-info-wrapper>
</template>

<script>
export default {
  props: {
    machineOwner: {
      type: Object,
      required: true
    }
  }

}
</script>

<style>

</style>
